import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./ProductDetailScreen.css";
import { formatCurrency } from "../../../format/formatDate";
import { Col, Row } from "react-bootstrap";
import ModalEnrollment from "../enrollment/ModalEnrollment";

const ProductDetailScreen = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [mainImage, setMainImage] = useState("");
  const [activeTab, setActiveTab] = useState("description");
  const [showModal, setShowModal] = useState(false);
  const [showEnrollment, setShowEnrollment] = useState(false);

  useEffect(() => {
    fetchProductDetails();
  }, [slug]);

  const fetchProductDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/product/public/show-by-slug/${slug}`);
      const data = response.data?.data || {};
      setProduct(data);
      if (data.imagesUrl && data.imagesUrl.length > 0) {
        setMainImage(data.imagesUrl[0]);
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = imageUrl => {
    setMainImage(imageUrl);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleMainImageClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="error-container">
        <p>Không tìm thấy sản phẩm</p>
        <button onClick={handleBackClick} className="back-button">
          Quay lại
        </button>
      </div>
    );
  }

  return (
    <div className="product-detail-container">
      <button onClick={handleBackClick} className="back-button">
        ← Quay lại
      </button>

      <div className="product-content">
        <div className="product-gallery">
          <div className="main-image-container" onClick={handleMainImageClick}>
            <img
              src={mainImage}
              alt={product.name}
              className="main-image"
              onError={e => {
                e.target.onerror = null;
                e.target.src = "/placeholder-image.jpg";
              }}
            />
          </div>
          {product.imagesUrl && product.imagesUrl.length > 1 && (
            <div className="gallery-thumbnails">
              {product.imagesUrl.map((imageUrl, index) => (
                <img
                  key={index}
                  src={imageUrl}
                  alt={`${product.name} - ${index + 1}`}
                  className={`gallery-image ${mainImage === imageUrl ? "selected" : ""}`}
                  onClick={() => handleImageClick(imageUrl)}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = "/placeholder-image.jpg";
                  }}
                />
              ))}
            </div>
          )}
        </div>

        <div className="product-info">
          <h1 className="product-name">{product.name}</h1>
          {product?.salePrice && Number(product?.salePrice) > 0 ? (
            <p className="product-price">
              {product.originalPrice ? (
                <span className="origin-price me-2">
                  {formatCurrency(product.originalPrice)} đ
                </span>
              ) : null}
              {formatCurrency(product.salePrice)} đ
            </p>
          ) : null}

          <button
            className="contact-button"
            onClick={() => setShowEnrollment(true)}
          >
            Liên hệ
          </button>

          {product.relatedProducts && product.relatedProducts.length > 0 && (
            <div className="related-products">
              <div className="related-products-list">
                {product.relatedProducts.map(relatedProduct => (
                  <button
                    key={relatedProduct.id}
                    className="view-related-btn"
                    onClick={() =>
                      navigate(
                        `/san-pham/${relatedProduct.category.slug}/${relatedProduct.slug}`
                      )
                    }
                  >
                    {relatedProduct.optionMappings &&
                      relatedProduct.optionMappings.length > 0
                      ? relatedProduct.optionMappings
                        .map(
                          (option, index) =>
                            `${option.value}${index < relatedProduct.optionMappings.length - 1 ? " - " : ""}`
                        )
                        .join("")
                      : relatedProduct.name}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={handleCloseModal}>
                ×
              </button>
              <img
                src={mainImage}
                alt={product.name}
                className="modal-image"
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = "/placeholder-image.jpg";
                }}
              />
            </div>
          </div>
        )}

        <ModalEnrollment
          show={showEnrollment}
          onHide={() => setShowEnrollment(false)}
          subject={`Cần mua sản phẩm: ${product.name}`}
        />
      </div>

      <Row>
        <Col md={12} className="product-tabs">
          <button
            className={`tab-button ${activeTab === "description" ? "active" : ""}`}
            onClick={() => setActiveTab("description")}
          >
            Mô tả
          </button>
          <button
            className={`tab-button ${activeTab === "specifications" ? "active" : ""}`}
            onClick={() => setActiveTab("specifications")}
          >
            Thông số kỹ thuật
          </button>
        </Col>

        <div className="tab-content">
          {activeTab === "description" && (
            <div className="description-content">
              <div dangerouslySetInnerHTML={{ __html: product.content }} />
            </div>
          )}

          {activeTab === "specifications" && (
            <div className="specifications-content">
              {product.attributeValues && product.attributeValues.length > 0 ? (
                <ul className="specifications-list">
                  {product.attributeValues.map((option, index) => (
                    <li key={index} className="specification-item">
                      <span className="spec-label">
                        {option.attribute.name}:
                      </span>
                      <span className="spec-value">{option.value}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Không có thông số kỹ thuật</p>
              )}
            </div>
          )}
        </div>
      </Row>
    </div>
  );
};

export default ProductDetailScreen;
